import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BASE_URL = "https://api.malidag.com";

const MenHeader = () => {
  const [selectedType, setSelectedType] = useState('');
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [menTypes, setMenTypes] = useState([]);

  useEffect(() => {
    const fetchMenTypes = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/items`);
        const data = response.data; // <-- fixed here

        const menItems = data.filter(
          (item) => item?.item?.genre?.toLowerCase() === 'men'
        );

        const uniqueTypes = [
          ...new Set(
            menItems
              .map((item) => item?.item?.type?.toLowerCase())
              .filter(Boolean)
          ),
        ];

        console.log('All items:', data);
        console.log('Men items:', menItems);
        console.log('Unique men types:', uniqueTypes);

        setMenTypes(uniqueTypes);
      } catch (error) {
        console.error('Error fetching men items:', error);
      }
    };

    fetchMenTypes();
  }, []);

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setImageUrl(null);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!selectedType) {
      alert('Please select a men type before uploading.');
      return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/men/${selectedType}/image`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setImageUrl(response.data?.imageUrl);
    } catch (error) {
      console.error('Error uploading image:', error.response?.data || error.message);
      alert('Failed to upload image. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Men Header</h1>

      <select value={selectedType} onChange={handleTypeChange}>
        <option value="">Select Men Type</option>
        {menTypes.map((type) => (
          <option key={type} value={type}>
            {type.replace(/-/g, ' ')}
          </option>
        ))}
      </select>

      {selectedType && (
        <>
          <input type="file" accept="image/*" onChange={handleImageUpload} />
          {loading && <p>Uploading...</p>}
        </>
      )}

      {imageUrl && (
        <div>
          <h2>Uploaded Image for {selectedType.replace(/-/g, ' ')}</h2>
          <img
            src={imageUrl}
            alt={selectedType}
            style={{ width: '100%', maxWidth: '1200px', height: 'auto', borderRadius: '8px' }}
          />
        </div>
      )}
    </div>
  );
};

export default MenHeader;